import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { CatalogModule } from '@app/shared/components/catalog/catalog.module';
import { SearchbarModule } from '@app/shared/components/searchbar/searchbar.module';
import { SharedModule } from '@app/shared/shared.module';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { HostnameLocalizationService } from '@app/core/i18n';
import { HomeMicrodatasService } from '@app/home/services/home-microdatas.service';
import { ImagesModule } from '@app/shared/components/images/images.module';
import { UserUtilsService } from '@app/library/services/user-utils.service';
import { ProductModule } from '@app/+product/product.module';

@NgModule({
  imports: [CommonModule, CatalogModule, SearchbarModule, SharedModule, ImagesModule, NgxJsonLdModule, ProductModule],
  declarations: [HomeComponent],
  providers: [HomeMicrodatasService, HostnameLocalizationService, UserUtilsService],
  exports: [HomeComponent, ImagesModule]
})
export class HomeModule {}
